import { createSlice } from "@reduxjs/toolkit";

const salesSlice = createSlice({
  name: "salesSetter",
  initialState: {
    tasks: {
      editTask: false,
      taskModal: {
        taskTitle: '',
        taskAssignee: '',
        taskType: '',
        taskDueDate: '',
        taskContact: '',
        taskReminder: '',
        taskReminderCustomDate: null,
        taskNote: '',
      },
      searchEvent: 'search',
    }
  },
  reducers: {
    setEditTask: (state, action) => {
      state.tasks.editTask = action.payload;
    },
    setSearchEvent: (state, action) => {
      state.tasks.searchEvent = action.payload;
    },
    setAssigneeId: (state, action) => {
      state.tasks.assigneeId = action.payload;
    }
  },
});

// Action creators are generated for each case reducer function
export const { setEditTask, setSearchEvent, setAssigneeId } =
  salesSlice.actions;

export default salesSlice.reducer;
